module.exports = "https://www.gc-pro.gnp.com.mx/2f0e56524998d6451ff785625e52ca04.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icon-lista-active.svg
// module id = 1833
// module chunks = 0